import { render, staticRenderFns } from "./ServiceItem.vue?vue&type=template&id=6acbce6a&scoped=true"
import script from "./ServiceItem.vue?vue&type=script&lang=js"
export * from "./ServiceItem.vue?vue&type=script&lang=js"
import style0 from "./ServiceItem.vue?vue&type=style&index=0&id=6acbce6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acbce6a",
  null
  
)

export default component.exports